module.exports = __webpack_public_path__ + "img/car.88467ff5.png";